/**
 * Utility function to decode a string delimited by ~ into a PatternColorCombination object.
 * If no delimiter is found, the same given string is returned.
 */
function decodePatternColorCombination (strPattern) {

	let i;
	const delimiter = '~';
	const pattern = (strPattern || '').split(delimiter);
	const len = pattern.length;
	let suffix;

	// if delimiter not found, return the same string
	if (len < 2) {

		return strPattern;

	}

	const jsonPattern = {
		PatternId: pattern[0],
		Trim: pattern[1]
	};

	suffix = 1;
	for (i = 2; i < len; i++) {

		jsonPattern[`LayerColor${suffix++}`] = pattern[i];

	}

	return jsonPattern;

}
function decodePatternColorCombinationWishList (strPattern) {

	const json = decodePatternColorCombination(strPattern);
	let i = 1;

	if (!json) {

		return;

	}

	while (json.hasOwnProperty(`LayerColor${i}`)) {

		json[`Color${i}`] = json[`LayerColor${i}`];
		delete json[`LayerColor${i}`];
		i++;

	}
	return json;

}
function decodePatternColorCombinationToCheckInWishList (strPattern) {

	const json = decodePatternColorCombination(strPattern);
	let i = 1;

	if (!json) {

		return;

	}

	while (json.hasOwnProperty(`LayerColor${i}`)) {

		const tmp = json[`LayerColor${i}`];
		json[`LayerColor${i}`] = { HexColor: tmp };
		i++;

	}
	return json;

}

export {
	decodePatternColorCombination,
	decodePatternColorCombinationToCheckInWishList,
	decodePatternColorCombinationWishList
};
